import { isNil, isNotNil } from "@etudescarre/utils";
import { EnvelopeSimple as EnvelopeIcon } from "@phosphor-icons/react";
import { apiClient } from "@/lib/api/client";
import {
  type PendingDispatchFetchArgs,
  type PendingDispatchPayload,
  PendingDispatchScreen,
} from "./pending-dispatch-screen";
import { PiecesAReunirTable } from "./pieces-a-reunir-table";

const EMPTY_LABEL = "Aucune mise au courrier en attente";

async function fetchMisesAuCourrier({
  yardId,
  target,
  recipientTeamId,
}: PendingDispatchFetchArgs): Promise<PendingDispatchPayload> {
  const { data, error } = await apiClient.GET(
    "/api/yards/{yardId}/mises-au-courrier",
    {
      params: {
        path: { yardId },
        query: {
          target,
          ...(isNotNil(recipientTeamId) ? { recipientTeamId } : {}),
        },
      },
    },
  );

  if (error || isNil(data)) {
    throw new Error("Erreur lors du chargement des mises au courrier");
  }
  return data.data;
}

/**
 * Écran 021 — « Préparer et enregistrer les mises au courrier » : bordereaux
 * à éditer et pièces à réunir pour les envois « courrier » en attente.
 */
export function MisesAuCourrier() {
  return (
    <PendingDispatchScreen
      title="Préparer et enregistrer les mises au courrier"
      errorLabel="Erreur lors du chargement des mises au courrier"
      emptyLabel={EMPTY_LABEL}
      pendingColumnLabel="Envois en attente"
      pendingIcon={EnvelopeIcon}
      tabBadgeTitle={(count) =>
        count > 0
          ? `${count} bordereau(x) à mettre au courrier`
          : "Aucune mise au courrier en attente"
      }
      fetchItems={fetchMisesAuCourrier}
      renderTable={({ loading, items }) => (
        <PiecesAReunirTable
          loading={loading}
          items={items}
          emptyLabel={EMPTY_LABEL}
        />
      )}
    />
  );
}
